import { defineMessages } from 'react-intl';

/** The Studio copy of the full videos, the lyric moment and the motion artwork (designs s7, s7b, s7c). */
export const fullVideoMessages = defineMessages({
  // Step 2 (s7c): the card states.
  chipReady: { id: 'app.sml.promote.studio.state.ready', defaultMessage: 'Ready to make' },
  chipNeedsLyrics: { id: 'app.sml.promote.studio.state.needsLyrics', defaultMessage: 'Needs the lyrics' },
  chipProPlan: { id: 'app.sml.promote.studio.state.freePlan', defaultMessage: 'Pro plan' },
  needsLyricsBody: {
    id: 'app.sml.promote.studio.state.needsLyricsBody',
    defaultMessage: 'Add the lyrics in the song files.',
  },
  addLyrics: { id: 'app.sml.promote.studio.state.addLyrics', defaultMessage: 'Add the lyrics' },
  planTitle: {
    id: 'app.sml.promote.studio.plan.title',
    defaultMessage: 'Make a video of the whole song',
  },
  planBodyOwner: {
    id: 'app.sml.promote.studio.plan.bodyOwner',
    defaultMessage: 'The whole song, for YouTube, from 3 credits.',
  },
  motionPlanTitle: {
    id: 'app.sml.promote.studio.plan.motionResultTitle',
    defaultMessage: 'Make your cover move',
  },
  motionPlanBodyOwner: {
    id: 'app.sml.promote.studio.plan.motionBodyOwner',
    defaultMessage: 'A moving cover for Apple Music, square and tall, for 3 credits.',
  },
  planSeePlans: { id: 'app.sml.promote.studio.plan.seePlans', defaultMessage: 'See the plans' },
  planUpgrade: { id: 'app.sml.promote.studio.plan.upgrade', defaultMessage: 'Upgrade' },
  planBodyMember: {
    id: 'app.sml.promote.studio.plan.bodyMember',
    defaultMessage: 'Ask the owner of the workspace to upgrade.',
  },
  // Step 2 (s7c, second row): the lyric sync boxes.
  syncingChip: { id: 'app.sml.promote.studio.sync.syncingChip', defaultMessage: 'Lyrics syncing' },
  syncingTitle: { id: 'app.sml.promote.studio.sync.syncingTitle', defaultMessage: 'The lyrics are syncing' },
  syncingBody: {
    id: 'app.sml.promote.studio.sync.syncingBody',
    defaultMessage: 'You can make it now. The video starts when the times are ready (about a minute).',
  },
  failedChip: { id: 'app.sml.promote.studio.sync.failedChip', defaultMessage: 'Sync failed' },
  failedTitle: { id: 'app.sml.promote.studio.sync.failedTitle', defaultMessage: 'We could not sync the lyrics' },
  failedBody: {
    id: 'app.sml.promote.studio.sync.failedBody',
    defaultMessage: 'Make the video with the times you set by hand, or fix them. A line with no time does not show.',
  },
  fixTimes: { id: 'app.sml.promote.studio.sync.fixTimes', defaultMessage: 'Fix the times' },
  // Step 3 of a full video (s7).
  lengthHint: { id: 'app.sml.promote.studio.full.lengthHint', defaultMessage: 'The video plays the whole master.' },
  lengthWhole: { id: 'app.sml.promote.studio.full.lengthWhole', defaultMessage: 'Whole song · {time}' },
  lengthWholeNoTime: { id: 'app.sml.promote.studio.full.lengthWholeNoTime', defaultMessage: 'Whole song' },
  lengthTrim: { id: 'app.sml.promote.studio.full.lengthTrim', defaultMessage: 'Trim' },
  trimNote: {
    id: 'app.sml.promote.studio.full.trimNote',
    defaultMessage: 'Trim cuts the start and the end, on a downbeat. At least 30 s.',
  },
  trimStart: { id: 'app.sml.promote.studio.full.trimStart', defaultMessage: 'Start' },
  trimEnd: { id: 'app.sml.promote.studio.full.trimEnd', defaultMessage: 'End' },
  trimSummary: {
    id: 'app.sml.promote.studio.full.trimSummary',
    defaultMessage: 'The video plays {from} – {to} ({length}).',
  },
  lyricsTitle: { id: 'app.sml.promote.studio.full.lyricsTitle', defaultMessage: 'Lyrics' },
  lyricsHint: {
    id: 'app.sml.promote.studio.full.lyricsHint',
    defaultMessage: 'The lines come in at their synced times.',
  },
  lyricsHintCaptions: {
    id: 'app.sml.promote.studio.full.lyricsHintCaptions',
    defaultMessage: 'The captions come in at their synced times.',
  },
  pillSynced: { id: 'app.sml.promote.studio.full.pillSynced', defaultMessage: 'Synced' },
  pillSyncing: { id: 'app.sml.promote.studio.full.pillSyncing', defaultMessage: 'Syncing' },
  pillFailed: { id: 'app.sml.promote.studio.full.pillFailed', defaultMessage: 'Failed' },
  pillNoLyrics: { id: 'app.sml.promote.studio.full.pillNoLyrics', defaultMessage: 'No lyrics' },
  lyricsLines: {
    id: 'app.sml.promote.studio.full.lyricsLines',
    defaultMessage: '{count, plural, one {# line} other {# lines}}',
  },
  lyricsLinesEdited: {
    id: 'app.sml.promote.studio.full.lyricsLinesEdited',
    defaultMessage: '{count, plural, one {# line} other {# lines}}, {edited} changed by you',
  },
  lyricsCheck: {
    id: 'app.sml.promote.studio.full.lyricsCheck',
    defaultMessage: '{count, plural, one {# line to check} other {# lines to check}}',
  },
  lyricsSyncingLine: {
    id: 'app.sml.promote.studio.full.lyricsSyncingLine',
    defaultMessage: 'The times come in about a minute. You can make it now.',
  },
  lyricsFailedLine: {
    id: 'app.sml.promote.studio.full.lyricsFailedLine',
    defaultMessage: 'Only the lines with a time show.',
  },
  lyricsNoneCaptions: {
    id: 'app.sml.promote.studio.full.lyricsNoneCaptions',
    defaultMessage: 'No captions: the song has no lyrics.',
  },
  checkTiming: { id: 'app.sml.promote.studio.full.checkTiming', defaultMessage: 'Check the timing' },
  // Step 3 of a lyric moment (s7b).
  linesTitle: { id: 'app.sml.promote.studio.moment.linesTitle', defaultMessage: 'Lines' },
  linesHint: {
    id: 'app.sml.promote.studio.moment.linesHint',
    defaultMessage: 'Click the first line, then the last. The video starts on the beat before it.',
  },
  linesSyncing: {
    id: 'app.sml.promote.studio.moment.linesSyncing',
    defaultMessage: 'The times come in about a minute.',
  },
  linesFoot: {
    id: 'app.sml.promote.studio.moment.linesFoot',
    defaultMessage:
      '{count, plural, one {# line} other {# lines}} · {length} s. The hook of the song is selected when the step opens.',
  },
  linesNotTimed: {
    id: 'app.sml.promote.studio.moment.linesNotTimed',
    defaultMessage: 'Some of these lines have no time yet. Set their times in the song files.',
  },
  linesEmpty: {
    id: 'app.sml.promote.studio.moment.linesEmpty',
    defaultMessage: 'Add the lyrics in the song files to pick the lines.',
  },
  tagHook: { id: 'app.sml.promote.studio.moment.tagHook', defaultMessage: 'Hook' },
  tagChorus: { id: 'app.sml.promote.studio.moment.tagChorus', defaultMessage: 'Chorus' },
  playLine: { id: 'app.sml.promote.studio.moment.playLine', defaultMessage: 'Play from {time}' },
  momentLengthHint: {
    id: 'app.sml.promote.studio.moment.lengthHint',
    defaultMessage: 'The lines decide the length; it rounds to 15 or 30 s.',
  },
  // The YouTube end screen of the long videos (designs y and z2): the last 20 s keep the right half free.
  endScreenTitle: { id: 'app.sml.promote.studio.full.endScreenTitle', defaultMessage: 'YouTube end screen' },
  endScreenHint: {
    id: 'app.sml.promote.studio.full.endScreenHint',
    defaultMessage:
      'The last 20 s show the end card on the left and keep the right half free. In YouTube Studio, pick the end screen template "1 video, 1 subscribe" and place it on the right half.',
  },
  // Step 3 of the motion artwork (s5, s7c).
  motionLengthHint: {
    id: 'app.sml.promote.studio.motion.lengthHint',
    defaultMessage: 'A silent loop. The last frame joins the first.',
  },
  motionFilesTitle: { id: 'app.sml.promote.studio.motion.filesTitle', defaultMessage: 'Files' },
  motionFiles: {
    id: 'app.sml.promote.studio.motion.files',
    defaultMessage: 'Two files: square 3840 × 3840 and tall 2048 × 2732, MP4 at 50 Mbit/s.',
  },
  motionWholeBars: { id: 'app.sml.promote.studio.motion.wholeBars', defaultMessage: 'Whole bars, about 20 s' },
  motionCoverSmall: {
    id: 'app.sml.promote.studio.motion.coverSmall',
    defaultMessage: 'Apple asks for 3840 × 3840. Your cover is {size} px, so the motion artwork is soft.',
  },
  motionPrice: {
    id: 'app.sml.promote.studio.motion.price',
    defaultMessage: '{count, plural, one {# credit} other {# credits}} for the pair.',
  },
  motionRule: {
    id: 'app.sml.promote.studio.motion.rule',
    defaultMessage: 'No text, no logo. The first frame is your cover, as Apple Music asks.',
  },
  // The rail (s7, s7b, s10).
  railFile: { id: 'app.sml.promote.studio.rail.file', defaultMessage: 'File' },
  railFileFull: { id: 'app.sml.promote.studio.rail.fileFull', defaultMessage: 'MP4 · for YouTube' },
  railFileMotion: { id: 'app.sml.promote.studio.rail.fileMotion', defaultMessage: 'MP4 · square and tall' },
  waitFull: {
    id: 'app.sml.promote.studio.rail.waitFull',
    defaultMessage:
      'Takes about {minutes} minutes for {length}. You can leave: it shows in Working on, and we email you.',
  },
  waitMoment: { id: 'app.sml.promote.studio.rail.waitMoment', defaultMessage: 'About 2 minutes.' },
  // The drawn previews (s1–s5).
  frameOfficialVideo: { id: 'app.sml.promote.studio.frame.officialVideo', defaultMessage: 'Official music video' },
  frameBankClip: { id: 'app.sml.promote.studio.frame.bankClip', defaultMessage: 'Bank clip' },
});
